import { QuestionnaireRules as QuestionnaireRules_1_0_0, ValueRules as ValueRules_1_0_0 } from './QuestionnaireRecipes_1_0_0.js';
import { cloneRule, overwriteRule } from '../RecipeUtils.js';
export const AtachmentRules = [
    {
        itemprop: 'contentType',
        itemtype: { type: 'string', regexp: /^(image\/png|image\/jpeg|image\/webp|image\/gif)$/ },
        optional: false
    },
    {
        itemprop: 'language',
        optional: true
    },
    {
        itemprop: 'data',
        optional: false
    },
    {
        itemprop: 'title',
        optional: true
    },
    {
        itemprop: 'creation',
        itemtype: {
            type: 'string',
            regexp: /([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1]))?)?/
        },
        optional: true
    }
];
export const ValueRules = cloneRule(ValueRules_1_0_0);
// FHIR Type: Attachment
ValueRules.push({
    itemprop: 'valueAttachment',
    itemtype: { type: 'object', rules: AtachmentRules },
    optional: true
});
/**
 * The rules to build a questionnaire based on FHIR
 */
export const QuestionnaireRules = cloneRule(QuestionnaireRules_1_0_0);
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'item',
    inheritFrom: 'Questionnaire_1_2_0.item',
    optional: true
});
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'initial',
    itemtype: {
        type: 'bag',
        item: {
            type: 'object',
            rules: ValueRules
        }
    },
    optional: true
});
/**
 * Recipe for questionnaires based upon FHIR standard.
 *
 * @type {{name: string; rule: RecipeRule[]; $type$: string}}
 */
export const QuestionnaireRecipe = {
    $type$: 'Recipe',
    name: 'Questionnaire_1_2_0',
    rule: QuestionnaireRules
};
const QuestionnaireRecipes = [QuestionnaireRecipe];
export default QuestionnaireRecipes;
//# sourceMappingURL=QuestionnaireRecipes_1_2_0.js.map